import {invalidValidationResult, ValidationResult} from "../../../util/validation/validation-result"
import React, {ChangeEvent} from "react"
import {FormTextInput} from "../../../components-shared/forms/form-text-input/form-text-input-view"
import {RadioButton, RadioButtonGroup} from "../../../components-shared/radio-button/radiobutton"
import {FuelType} from "../../../domain/fuel-type"
import {FormField} from "../../../components-shared/forms/form-field/form-field"
import {gaSendClimateAdviceEvent} from "../../../services/analytics/google-analytics-helper"

export interface FormImprovementInputProps {
  description: string
  value: string
  onChange: (numericValueAndValidationResult: NumericValueAndValidationResult) => void
  validationResult: ValidationResult
}

export const FormImprovementNumberInput: React.FC<FormImprovementInputProps> = ({description, value, onChange, validationResult}) => {
  const change = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(parseAndValidate(e.target.value))
    gaSendClimateAdviceEvent("Edit field")
  }

  return <FormTextInput type="number" label={description} value={value} onChange={change} showValidity={true} validationResult={validationResult}/>
}

export const FormImprovementFuelInput: React.FC<FormImprovementInputProps> = ({ value, onChange, validationResult}) => {
  const change = (e: ChangeEvent<HTMLInputElement>) => {
    onChange({
      resultType: "fuelType",
      value: e.target.value as FuelType,
      partialValidationResult: {valid: true}
    })
    gaSendClimateAdviceEvent("Edit field")
  }

  return <FormField label="Brandstof" showValidity={false} validationResult={validationResult}>
    <RadioButtonGroup validationResult={validationResult}>
      <RadioButton name="fuelType" value="Gasoline" checked={value === "Gasoline"} label="Benzine" onChange={change}/>
      <RadioButton name="fuelType" value="Diesel" checked={value === "Diesel"} label="Diesel" onChange={change}/>
      <RadioButton name="fuelType" value="Lpg" checked={value === "Lpg"} label="Lpg" onChange={change}/>
    </RadioButtonGroup>
  </FormField>
}

const getDecimal = (stringValue: string): number | undefined => {
  if (stringValue === "") return undefined
  try {
    return parseFloat(stringValue)
  } catch (err) {
    return undefined
  }
}

const parseAndValidate = (value: string): NumericValueAndValidationResult => {
  const numericValue = getDecimal(value)
  const resultType = "numeric"

  if (value === null || value === "")
    return {resultType, value, numericValue, partialValidationResult: {valid: true}}
  if (numericValue !== undefined && numericValue.toString() !== value)
    return {resultType, value, numericValue: undefined, partialValidationResult: invalidValidationResult("Vul alstublieft een geldig getal in")}

  return {resultType, value, numericValue, partialValidationResult: {valid: true}}
}

export interface NumericValueAndValidationResult {
  resultType: "numeric" | "fuelType"
  value: string
  numericValue?: number
  partialValidationResult: ValidationResult
}